import { button } from "@/helper/locale/base/base_button.th"
import base_otp from "@/helper/locale/base/base_otp.th"
import { date } from "@/helper/locale/base/base_date.th"

export default {
    base_button: button,
    base_otp,
    base_date: date,
    exchangeName: "Yes Coin",

    init: {
        checkWalletAddress: "กรุณาตรวจสอบหมายเลข Wallet Address ให้ครบถ้วน สามารถคัดลอกหมายเลข Wallet Address ได้ที่แอพพลิเคชั่น Bitkub NEXT",
        enterWalletAddress: "กรุณาระบุหมายเลข Wallet Address ของ Bitkub NEXT",
    },
    walletAddress: "Wallet Address",
    buttons: {
        continue: "ไปต่อ",
        backToHome: "กลับไปหน้าหลัก",
        tryAgain: "ลองใหม่อีกครั้ง",
    },
    convert: {
        title: {
            convert: "โอน",
            textTo: "เป็น"
        },
        enter: "เบอร์โทรศัพท์ของคุณ",
        contact_number: {
            name: "เบอร์โทรศัพท์ของคุณ",
            placeholder: "",
            required: "Please True number",
            too_short: "",
            invalid: ""
        },
        identifier_no: {
            name: "เบอร์โทรศัพท์ของคุณ",
            placeholder: "",
            required: "",
            too_short: "",
            invalid: ""
        },
        current_point: "Your {0}",
        after_point: "คะแนนคงเหลือหลังการโอน",
        please_enter: "ระบุ",
        continue: "ดำเนินการต่อ",

        not_found_err_title: "ไม่พบ {0}",
        not_found_err: "{0} {1} ที่ท่านระบุไม่พบว่าเป็นสมาชิกในระบบ</br></br>กรุณากรอก {0} ใหม่อีกครั้ง",
        not_verified_err: "ไม่สามารถทำรายการได้ เนื่องจากบัญชีผู้ใช้งานนี้ยังไม่ยืนยันตัวตน",
        user_account_frozen_err: "ไม่สามารถทำรายการได้เนื่องจากบัญชีผู้ใช้ถูกระงับชั่วคราว",
        exceed_daily_err: "ไม่สามารถทำรายการได้เนื่องบัญชีผู้ใช้งานทำรายการเกินขีดจำกัดแล้วในวันนี้",
        balance_limit_err: "ไม่สามารถทำรายการได้เนื่องจากยอดเงินในบัญชีผู้ใช้ถึงขีดจำกัด",

        update_err_title: "ปรับปรุงข้อมูล {0}",

        convert_err_title: "การโอนคะแนนผิดพลาด",
        convert_err: "กรุณาติดต่อ call center</br>",

        other_err_title: "มีบางอย่างผิดปกติ",
        other_err: "ไม่สามารถทำรายการได้ กรุณาลองใหม่อีกครั้ง",

        point_not_enough_err: "ขออภัย คะแนนของคุณไม่ถึงจำนวนที่กำหนด กรุณาตรวจสอบอีกครั้ง",
        topup_too_high: "ไม่สามารถทำรายการได้เนื่องจากยอดเติมเงินสูงเกินกำหนด",
        topup_too_low: "ไม่สามารถทำรายการได้เนื่องจากยอดเติมเงินต่ำเกินกำหนด",

        re_enter: "ใส่ข้อมูลใหม่",
        close: "ปิด",
        back_to_campaign: "กลับสู่หน้าแคมเปญ",

        retry: "ลองอีกครั้ง",
        back: "กลับ"
    },
    result: {
        successfully: "การโอนคะแนนสำเร็จ",
        new_point: "New {0}",
        your_convert: "คุณได้โอน",
        please_check_balance: "กรุณาตรวจสอบยอดเงินคงเหลือของคุณผ่าน ShopeePay Application",
        back_to_campaign: "กลับสู่หน้าหลัก"
    },
    ptmax: {
        not_found_card: "ไม่พบหมายเลขบัตรพีทีแมกซ์",
        not_found_card_message: "หมายเลขบัตรพีทีแมกซ์ {xxx-xxx-xxxx} ที่ท่านระบุไม่พบว่าเป็นสมาชิกในระบบ <br/><br/>กรุณากรอกหมายเลขบัตรพีทีแมกซ์ใหม่อีกครั้ง",
    },
    confirm: {
        title: "ยืนยันการโอนคะแนน",
        member: "สมาชิก",
        warning_text: "เมื่อยืนยันการโอนคะแนนแล้วไม่สามารถยกเลิกได้",
        submit: "ยืนยัน",
        cancel: "ยกเลิก"
    },
    otp: {
        headline: 'การยืนยัน OTP',
        contact_number_lbl: 'เราได้ส่ง OTP ไปยังหมายเลข<br/>{0}',
        ref_code: 'หมายเลขอ้างอิง : ',

        please_enter_otp: 'กรุณากรอกรหัส OTP',
        time_left: 'ส่ง OTP อีกครั้งได้ภายใน',
        second: 'นาที',

        required: 'Please enter your OTP.',
        too_short: 'Please enter otp',
        otp_timeout: 'OTP time out in',
        resend_otp: 'ส่ง OTP อีกครั้ง',

        incorrect_otp: 'รหัส OTP ไม่ถูกต้อง กรุณาลองใหม่อีกครั้ง',
        cancel: "ยกเลิก",
        btn_confirm: "ยืนยันและทำการโอนคะแนน"
    },
    errors: {
        walletNotFound: {
            title: "Bitkub NEXT Wallet Address Not Found",
            message: "Your entered Bitkub NEXT Wallet Address <br /> {0} <br/> has not found on our system.<br/><br/>Please try again or enter another wallet address."
        },
        somethingWrong: {
            title: "Something Went Wrong",
            message: "Sorry, we are not able to proceed your request.<br />Please try again"
        },
    }
}
